module.exports = __webpack_public_path__ + "media/stylesheets/images/main/rank/top2-bcaa28653495e0d925326f90b90fdc2f.svg";